export class TextStyle {
    color?: string;
    fontName?: string;
    fontSize?: string | number;
    bold?: boolean;
    italic?: boolean;
}
